import * as style from '../../utils/general_style.js';

function Response({ question, answer, onToggle, isActive }) {

    const accordionStyle = {
        ...style.ROW_SPACE_BETWEEN,
        padding: style.SPACE.medium,
        border: `1px solid ${style.COLORS.grey}`
    };

	return (
        <>
            <div style={{outline: `1px solid ${style.COLORS.grey}`}}>
                <div style={{...accordionStyle, fontWeight: 'bolder', cursor: 'pointer', backgroundColor: (isActive) ? style.COLORS.lightGrey : style.COLORS.white, transition: 'background-color 0.3s ease-in-out'}} onClick={onToggle}>
                    <div>{question}</div>
                    <div style={{color: style.COLORS.primary}}>{isActive ? <i className="fa-solid fa-circle-chevron-up"></i> : <i className="fa-solid fa-circle-chevron-down"></i>}</div>
                </div>
                <div className='paragraph' style={{...accordionStyle, ...style.COLUMN_CENTER, alignItems: 'inherit', fontSize: '14px', display: (isActive) ? 'flex' : 'none'}}>{answer}</div>
            </div>
        </>
	);
};

export default Response;